import { ICheckConnection } from '@/contracts/modules/education/use-case/ICheckConnection'
import { EnumApiError } from '@/contracts/core/api/enum/EnumApiError'
import { GetSettingsRoute } from '@/modules/education/v1/api/v1/settings/GetSettings/GetSettingsRoute'

/** Коды, при которых связи с сервером нет: сбой сети, не JSON стандарта обмена, api-frontend не достучался до сервиса (502, 504) */
export const CONNECTION_LOST_CODES: string[] = [EnumApiError.NETWORK_ERROR, EnumApiError.BAD_RESPONSE, 'service_unavailable']

export function isConnectionLost(code: string): boolean {
  return CONNECTION_LOST_CODES.includes(code)
}

export class CheckConnection implements ICheckConnection {
  async exec(): Promise<boolean> {
    const response = await new GetSettingsRoute().exec(null)
    return response.isSuccess() || !isConnectionLost(response.getError())
  }
}
